import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';
import { AppState } from '../../../interfaces/app-state.interface';
import { ChatAssessorService } from './../chat-assessor.service';

@Injectable()
export class ConversationService {

    public previousText: string = '';
    public userMessagens: Subject<any>;
    public messagesNumber: number = 0;
    public userTypingMessage: Subject<any>;
    public assessorMessagens$: Observable<any>;
    public userTypingMessage$: Observable<any>;

    private userMessagens$: Observable<any>;
    private assessorMessagens: Subject<any>;

    /**
     * responsavel por enviar as messagens do front para o back
     * e receber as do back e mandar para o front
     *
     * @param chatAssessorService sales force service
     */
    constructor(
        private chatAssessorService: ChatAssessorService,
    ) {

        // Assessor messagens
        this.assessorMessagens = new Subject();
        this.assessorMessagens$ = this.assessorMessagens.asObservable();

        // User messagens
        this.userMessagens = new Subject();
        this.userMessagens$ = this.userMessagens.asObservable();

        // User typing messagens
        this.userTypingMessage = new Subject();
        this.userTypingMessage$ = this.userTypingMessage.asObservable();

        // Se inscreve para ficar ouvindo de onde vem
        this.getUserMessagens();
        this.getUserTypingMessage();
        this.getAssessorMenssagens();
    }

    /**
     * Inicia o chat com o assessor
     *
     * @param  {string='SemAssunto'} subject
     */
    public startChat( subject: string = 'Sem Assunto' ) {
        // Start chat
        this.chatAssessorService.getSessionID( subject );
    }

    /**
     *  Envia as msg do assessor pro front
     */
    public getAssessorMenssagens() {
        this.chatAssessorService.assessorMessagens$.subscribe((msg) => this.assessorMessagens.next(msg));
    }

    /**
     * Recebe as msg do user do front
     */
    public getUserMessagens() {
        this.userMessagens$.subscribe((msg) => this.chatAssessorService.sendMessagens(msg));
    }

    /**
     * Retorna o tipo da mensagem recebida
     */
    public getUserTypingMessage() {
        this.userTypingMessage$.subscribe((msg) => {
            this.messagesNumber = this.findFirstDiffPos(this.previousText, msg.message);
            this.previousText = msg.message;
            msg.message = msg.message.slice(this.messagesNumber);
            this.chatAssessorService.sendTypingMessage(msg, this.messagesNumber);
            this.messagesNumber++;
        });
    }

    /**
     * ?
     * @param  {} a
     * @param  {} b
     */
    public findFirstDiffPos(a, b) {
        let i = 0;
        if (a === b) return -1;
        while (a[i] === b[i]) i++;
        return i;
    }

}
